import React from 'react'; 
import './Home.css';
import '@fortawesome/fontawesome-free/css/all.min.css';


function Home() {
  return (
    <section id="home" className="home-section">
      <img src={`${process.env.PUBLIC_URL}/profile.jpg`} alt="Profile" className="profile-pic"/>
      <h2>Welcome to my portfolio!</h2>
      <div className="social-links"> 
        <a href="https://github.com/dehtaj" target="_blank" rel="noopener noreferrer"> <i className="fab fa-github"></i> </a>
        <a href="https://www.linkedin.com/in/dehtaj-shaik-43350721b/" target="_blank" rel="noopener noreferrer"> <i className="fab fa-linkedin"></i> </a> 
        <a href="https://www.instagram.com/winningloser_/" target="_blank" rel="noopener noreferrer"> <i className="fab fa-instagram"></i> </a>
        <a href="https://www.facebook.com/Dehtaj/" target="_blank" rel="noopener noreferrer"> <i className="fab fa-facebook"></i> </a>
      </div>
        
    </section>
  );
}

export default Home;
